import React, { useEffect } from 'react'
import { Box, Link, Space, TextBody, TextHeading } from '@ally/metronome-ui'
import allytm from '@ally/allytm'

export const InvestBeneficiaries: React.FC<{ headerRef: any }> = ({
  headerRef,
}) => {
  useEffect(() => {
    allytm.event('pageview', 'AOS:Beneficiaries:Invest')
  }, [])

  return (
    <Box data-testid="invest-content">
      <Space pt="md">
        <TextHeading
          tag="h2"
          size="md"
          weight="bold"
          tabIndex={-1}
          ref={headerRef}
        >
          Investments
        </TextHeading>
        <TextBody tag="p" size="sm">
          To add or edit a beneficiary for your Invest IRAs, download the{' '}
          <Link
            text="IRA
        Beneficiary Form (PDF)"
            href="/ext-storefront/resources/pdf/invest/invest-ira-beneficiary.pdf"
            target="_blank"
            allytmln="invest beneficiaries-IRA beneficiary form download"
          />{' '}
          . You&apos;ll find information for submitting it to us on the form.
        </TextBody>
        <TextBody tag="p" size="sm">
          To add or edit a beneficiary for your other Investments, download the{' '}
          <Link
            text="Beneficiary Form (PDF)"
            href="/ext-storefront/resources/pdf/invest/non-ira-beneficiary-election.pdf"
            target="_blank"
            allytmln="invest beneficiaries-beneficiary form download"
          />{' '}
          .
        </TextBody>
      </Space>
    </Box>
  )
}
